import { ApiError } from '@/api/client'

/** Standard empty-state copy for failed / missing analytics sections. */
export const NO_DATA_FOUND = 'No data found'

/**
 * Gateway / transport failures (Vite proxy 502 when :3910/:3920 is down,
 * timeouts, connection refused). Business 4xx and contract 503 Unavailable
 * bodies are NOT treated as unreachable — callers handle those separately.
 */
export function isUnreachableApiError(err: unknown): boolean {
  if (err instanceof ApiError) {
    return err.status === 0 || err.status === 502 || err.status === 503 || err.status === 504
  }
  return true
}

/** Short operator-facing reason — never echo raw HTML gateway pages. */
export function unreachableMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 0 || err.status === 502 || err.status === 503 || err.status === 504) {
      return 'The service did not respond. Sections below show No data found until it is reachable.'
    }
    if (typeof err.message === 'string' && err.message && !err.message.includes('<')) {
      return err.message
    }
    return `Request failed (${err.status})`
  }
  if (err instanceof Error && err.message && !err.message.includes('<')) return err.message
  return 'The service did not respond. Sections below show No data found until it is reachable.'
}
